<div class="flex flex-1 flex-row items-center gap-1">
  @switch (item.config?.dataType) {
    @default {
      <ng-container [ngTemplateOutlet]="text"></ng-container>
    }
    @case ("text") {
      <ng-container [ngTemplateOutlet]="text"></ng-container>
    }
    @case ("textmultiline") {
      <ng-container [ngTemplateOutlet]="text"></ng-container>
    }
    @case ("number") {
      <ng-container [ngTemplateOutlet]="number"></ng-container>
    }
    @case ("date") {
      <ng-container [ngTemplateOutlet]="date"></ng-container>
    }
    @case ("datetime") {
      <ng-container [ngTemplateOutlet]="date"></ng-container>
    }
  }

  @if (item.config.quickview) {
    <div class="flex items-center justify-center">
      <i class="fa-light fa-eye opacity-50"></i>
    </div>
  }
</div>

<ng-template #text>
  <div class="relative flex flex-1 flex-col">
    <dx-form
      [formData]="formData"
      (onFieldDataChanged)="onFieldDataChanged($event)"
      [readOnly]="readOnly"
      class="flex-1"
    >
      <dxi-item
        dataField="value"
        [editorType]="
          item.config?.dataType === 'textmultiline' ? 'dxTextArea' : 'dxTextBox'
        "
        [editorOptions]="{
          valueChangeEvent: 'keyup',
          maxLength: textMaxLength,
          minHeight: item.config?.dataType === 'textmultiline' ? 64 : undefined,
          autoResizeEnabled:
            item.config?.dataType === 'textmultiline' ? true : false
        }"
        [label]="{
          text: item.config?.title,
          location: 'top',
          showColon: false,
          visible: !!item.config?.title
        }"
      ></dxi-item>
    </dx-form>
    <span
      class="absolute bottom-[16px] right-[12px] text-xs text-slate-400 pointer-events-none"
      >{{ currentTextLength }}/{{ textMaxLength }}</span
    >
  </div>
</ng-template>

<ng-template #number>
  <dx-form
    [formData]="formData"
    class="flex-1"
    [colCount]="3"
    [readOnly]="readOnly"
    (onFieldDataChanged)="onFieldDataChanged($event)"
  >
    <dxi-item
      dataField="value"
      [editorType]="'dxNumberBox'"
      [editorOptions]="{ step: 0, valueChangeEvent: 'keyup' }"
      [label]="{
        text: item.config?.title,
        location: 'top',
        showColon: false,
        visible: !!item.config?.title
      }"
    ></dxi-item>
  </dx-form>
</ng-template>

<ng-template #date>
  <dx-form
    [formData]="formData"
    class="flex-1"
    [colCount]="3"
    [readOnly]="readOnly"
    (onFieldDataChanged)="onFieldDataChanged($event)"
  >
    <dxi-item
      dataField="value"
      [editorType]="'dxDateBox'"
      [editorOptions]="{
        type: item.config?.dataType === 'date' ? 'date' : 'datetime',
        valueChangeEvent: 'keyup'
      }"
      [label]="{
        text: item.config?.title,
        location: 'top',
        showColon: false,
        visible: !!item.config?.title
      }"
    ></dxi-item>
  </dx-form>
</ng-template>
